import { render, staticRenderFns } from "./CampaignIndexTable.vue?vue&type=template&id=6383e5d8&scoped=true"
import script from "./CampaignIndexTable.vue?vue&type=script&lang=js"
export * from "./CampaignIndexTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignIndexTable.vue?vue&type=style&index=0&id=6383e5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6383e5d8",
  null
  
)

export default component.exports